<template>
  <!-- ViewClassroomCurriculum.vue:
  강의실 > 커리큘럼 화면 (online-class.html, online-class1.html)-->

  <fragment>
    <class-header
      :subname="subname"
      :name="name"
      v-bind:menus="menus"
      v-bind:buttons="buttons"
      v-bind:mainmenuOpened="true"
      v-bind:sysmenuActive="false"
      :icon="lec.lecIcon?lec.lecIcon.atchFileId:''"
    ></class-header>

    <section ref="container" class="container">
      <!-- side menus -->
      <common-side-menu
        :menus="side_menus"
        :btnList="side_buttons"
        :key="'side-menu-'+hash(side_menus)+hash(side_buttons)"
      ></common-side-menu>
      <!-- //end .side-nav -->
      <div class="container-fiuld clearfix">
        <ul class="m-b-30" v-if="selectedCurriculum">
          <li>
            <div class="title-box b-b clearfix">
              <div class="f-18 pull-left p-15 text-blue">{{selectedCurriculum.name}}</div>
              <div class="pull-right w100 p-15">
                <a class="modify m-r-5" @click="modifyCurriculum">수정</a>
                <a class="del" @click="deleteCurriculum">삭제</a>
              </div>
            </div>
            <table class="table2 table-condensed m-t-10 text-center">
              <tbody>
                <tr class="bg-none" style="box-shadow: none;">
                  <td class="p-0" colspan="3">
                    <div class="input-group full-width">
                      <span class="input-group-addon v-mid p-r-5">
                        <input
                          class="form-control-sm full-width m-b-0 round"
                          type="text"
                          placeholder=" 차시명을 입력하고 엔터키 혹은 추가 버튼을 클릭하세요."
                          v-model="newLesGroupTitle"
                          @keydown.enter="addLesGroup"
                        />
                      </span>
                      <span class="input-group-addon w100 v-mid">
                        <button
                          class="btn-sm bg-deepblue full-width text-white round v-mid"
                          type="button"
                          @click="addLesGrp"
                        >차시추가</button>
                      </span>
                    </div>
                  </td>
                </tr>
                <tr class="margin">
                  <td colspan="3"></td>
                </tr>
              </tbody>
              <tbody
                v-for="(lesGrp, lesGrpIdx) in selectedCurriculum.lesList"
                :key="'les-list-for-'+selectedCurriculum.curriculumId+'-'+lesGrpIdx+'-'+hash(lec.curriculumList[selectedCurriculumIdx])"
                :item="lesGrp"
                :index="lesGrpIdx"
              >
                <tr v-if="lesGrp.modify_!=true" class="on">
                  <th class="w80">
                    <div class="w80 b-r">{{lesGrp.no}} 차시</div>
                  </th>
                  <th class="full-width p-10 text-left">{{lesGrp.title}}</th>
                  <th class="p-10 w100">
                    <a class="move m-r-5" @click="moveUpLesGrp(lesGrp)">△</a>
                    <a class="move m-r-5" @click="moveDownLesGrp(lesGrp)">▽</a>
                    <a class="modify m-r-5" @click="modifyLesGrp(lesGrpIdx)">수정</a>
                    <a class="del" @click="deleteLesGrp(lesGrpIdx)">삭제</a>
                  </th>
                </tr>
                <tr v-if="lesGrp.modify_==true">
                  <th class="w80">
                    <div class="w80 b-r">{{lesGrp.no}} 차시</div>
                  </th>
                  <td class="p-0" colspan="2">
                    <div class="input-group full-width">
                      <span class="input-group-addon v-mid p-r-5">
                        <input
                          class="form-control-sm full-width m-b-0 round"
                          type="text"
                          v-model="lesGrp.title"
                        />
                      </span>
                      <span class="input-group-addon w100 v-mid">
                        <button
                          class="btn-sm bg-deepblue full-width text-white round v-mid"
                          type="button"
                          @click="modifyLesGrpConfirm(lesGrpIdx)"
                        >수정완료</button>
                      </span>
                    </div>
                  </td>
                </tr>
                <tr class="margin">
                  <td colspan="3"></td>
                </tr>
                <tr>
                  <td class="round" colspan="3">
                    <table class="full-width">
                      <tbody>
                        <tr>
                          <td>
                            <input
                              class="form-control-sm full-width m-b-0 round v-mid"
                              type="text"
                              placeholder="단원명을 입력하세요."
                              v-model="lesGrp.newLes_.title"
                            />
                          </td>
                          <td class="w360">
                            <button
                              class="btn-sm bg-blue full-width text-white round v-mid"
                              type="button"
                              :ref="'connContPath-'+lesGrpIdx"
                              @click="onAddCMS(lesGrpIdx,'connContPath')"
                            >강의 콘텐츠 (CMS)</button>
                          </td>
                          <td class="w140">
                            <input
                              class="form-control-sm w100 m-b-0 round"
                              type="text"
                              placeholder="쪽 수"
                              v-model="lesGrp.newLes_.connContPages"
                            />
                          </td>
                          <td class="w360">
                            <button
                              class="btn-sm bg-blue full-width text-white round v-mid"
                              type="button"
                              :ref="'connMaterial-'+lesGrpIdx"
                              @click="onAddCMS(lesGrpIdx,'connMaterial')"
                            >강의 자료 (CMS)</button>
                          </td>
                          <td class="w100">
                            <label>
                              <input type="checkbox" v-model="lesGrp.newLes_.previewEnable" /> 맛보기강좌
                            </label>
                            <button
                              class="btn-sm bg-deepblue w100 text-white round v-mid"
                              type="button"
                              @click="addLes(lesGrp, lesGrpIdx)"
                            >단원추가</button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                    <vue-draggable
                      v-model="lesGrp.child"
                      tag="table"
                      class="full-width"
                      handle=".handle"
                      v-bind="dragOptions"
                      @end="dragEnd(lesGrpIdx)"
                    >
                      <tbody
                        v-for="(les, lesIdx) in lesGrp.child"
                        :key="'les-list-for-'+lesGrpIdx+'-'+lesIdx+'-'+hash(lec.curriculumList[selectedCurriculumIdx].lesList[lesGrpIdx].lesList[lesIdx])"
                        :item="les"
                        :index="lesIdx"
                      >
                        <tr v-if="les.modify_!=true">
                          <td>{{lesIdx+1}} 단원</td>
                          <td><span :style="les.previewEnable?'color:red;font-weight:nbold;':''">{{les.previewEnable?'(맛보기 강좌)':''}}</span> {{les.title}}</td>
                          <td class="w360">{{les.connContPath}} ({{les.connContSize}})</td>
                          <td class="w140">{{les.connContPages}} 쪽</td>
                          <td class="w360">{{les.connMaterial}}</td>
                          <td class="w120">
                            <a class="move m-r-5 handle">이동</a>
                            <a class="modify m-r-5" @click="modifyLes(lesGrpIdx, lesIdx)">수정</a>
                            <a class="del" @click="deleteLes(lesGrpIdx, lesIdx)">삭제</a>
                          </td>
                        </tr>
                        <tr v-if="les.modify_==true">
                          <td>{{lesIdx+1}} 단원</td>
                          <td>
                            <input
                              class="form-control-sm full-width m-b-0 round"
                              type="text"
                              v-model="les.title"
                            />
                          </td>
                          <td>
                            <button
                              class="btn-sm bg-blue full-width text-white round v-mid"
                              type="button"
                              :ref="'connMaterial-modify-'+les.lesId"
                              @click="onAddCMS(les.lesId,'connContPath',true)"
                            >강의 자료 (CMS)</button>
                          </td>
                          <td>
                            <input
                              class="form-control-sm w100 m-b-0 round"
                              type="text"
                              placeholder="쪽 수"
                              v-model="les.connContPages"
                            />
                          </td>
                          <td>...</td>
                          <td>
                            <button
                              class="btn-sm bg-deepblue full-width text-white round v-mid"
                              type="button"
                              @click="modifyLesConfirm(lesGrpIdx,lesIdx)"
                            >수정완료</button>
                          </td>
                        </tr>
                      </tbody>
                    </vue-draggable>
                  </td>
                </tr>
                <tr class="margin">
                  <td colspan="3"></td>
                </tr>
              </tbody>
            </table>
          </li>
        </ul>
      </div>
      <modal-class-contents-register
        :config="modals.classContentsRegister"
        :key="'class-contents-register-modal-'+hash(modals.classContentsRegister)"
        @selected="onCMSSelected"
      ></modal-class-contents-register>
      <modal-curriculum-compile
        :config="modals.curriculumCompile"
        :key="'curriculum-compile-modal-'+hash(modals.curriculumCompile)"
        @CurriculumSelected="onCurriculumSelected"
      ></modal-curriculum-compile>
      <modal-curriculum-register
        :config="modals.curriculumRegister"
        :key="'curriculum-register-modal-'+hash(modals.curriculumRegister)"
        @CurriculumSelected="onCurriculumSelected"
        @CurriculumModified="refresh();"
      ></modal-curriculum-register>
      <modal-alert
        :config="modals.ModalAlert"
        @close="modals.ModalAlert.show=false;"
        :key="hash(modals.ModalAlert)"
      ></modal-alert>
      <modal-confirm
        :config="modals.ModalConfirm"
        @close="modals.ModalConfirm.show=false;"
        :key="hash(modals.ModalConfirm)"
      ></modal-confirm>

      <common-footer></common-footer>
    </section>
    <common-footer></common-footer>
  </fragment>
</template>

<script>
import ModalCurriculumRegister from "../modals/ModalCurriculumRegister.vue";
import ModalClassContentsRegister from "../modals/ModalClassContentsRegister.vue";
import ModalCurriculumCompile from "../modals/ModalCurriculumCompile.vue";
import ModalAlert from "../modals/ModalAlert.vue";
import ModalConfirm from "../modals/ModalConfirm.vue";

import fnAdjustHeight from "../mixins/fnAdjustHeight.js";
import ClassHeader from "../components/ClassHeader.vue";
import CommonFooter from "../components/CommonFooter.vue";
import CommonSideMenu from "../components/CommonSideMenu.vue";
import VueDraggable from "vuedraggable";
import axios from "axios";
import server from "../statics/server.js";

export default {
  // 컴포넌트 명
  name: "ViewClassroomCurriculum",
  mixins: [fnAdjustHeight],
  // 이 컴포넌트에서 사용할 자식컴포넌트 목록
  components: {
    ClassHeader,
    CommonFooter,
    CommonSideMenu,
    ModalClassContentsRegister,
    ModalCurriculumCompile,
    ModalCurriculumRegister,
    ModalAlert,
    ModalConfirm,
    VueDraggable
  },

  mounted: function() {
    this.refresh();
  },

  // 이 컴포넌트에서 내부적으로 사용할 데이터
  data: function() {
    return {
      subname: "",
      name: "",
      menus: [
        {
          name: "강의 목차",
          link: "/classroom/" + this.$route.params.lecId + "/curriculum",
          selected: true
        },
        {
          name: "수강관리",
          link: "/classroom/" + this.$route.params.lecId + "/apply",
          selected: false
        },
        {
          name: "출결",
          link: "/classroom/" + this.$route.params.lecId + "/attendance",
          selected: false
        },
        {
          name: "시험",
          link: "/classroom/" + this.$route.params.lecId + "/exam",
          selected: false
        },
        {
          name: "과제",
          link: "/classroom/" + this.$route.params.lecId + "/assignment",
          selected: false
        },
        {
          name: "설문",
          link: "/classroom/" + this.$route.params.lecId + "/survey",
          selected: false
        },
        {
          name: "게시판",
          link: "/classroom/" + this.$route.params.lecId + "/board",
          selected: false
        }
      ],
      side_menus: [
        // 사이드 메뉴
        { name: "강의 목차가 없습니다.", link: "" }
      ],
      side_buttons: [
        { name: "강의 목차 가져오기", fn: this.onGetCurriculum },
        { name: "새 강의 목차 만들기", fn: this.onCreateCurriculum }
      ],
      buttons: [{ name: "수정저장", fn: this.onSaveComplate }],
      modals: {
        curriculumRegister: ModalCurriculumRegister.default(),
        classContentsRegister: ModalClassContentsRegister.default(),
        curriculumCompile: ModalCurriculumCompile.default(),
        ModalAlert: ModalAlert.default(),
        ModalConfirm: ModalConfirm.default()
      },

      lec: {},
      lec_: {},
      selectedCurriculum: null,
      selectedCurriculumIdx: 0,
      newLesGroupTitle: "",
      newLesName: "",
      newConnContPath: ""
    };
  },
  // 이 컴포넌트에서 내부적으로 사용할 메써드
  methods: {
    // 강좌정보 조회
    refresh: function() {
      // 강좌 상세정보 조회
      axios
        .post(
          server.addr() + server.api.LECTURE + "/" + this.$route.params.lecId
        )
        .then(response => {
          this.subname = response.data.return.category;
          this.name = response.data.return.lecName;
          this.lec = response.data.return;
          if (this.lec.classroomOpt.indexOf("출결") == -1)
            this.menus.splice(
              this.menus.indexOf(this.menus.find(e => e.name == "출결")),
              1
            );
          if (this.lec.classroomOpt.indexOf("과제") == -1)
            this.menus.splice(
              this.menus.indexOf(this.menus.find(e => e.name == "과제")),
              1
            );
          if (this.lec.classroomOpt.indexOf("설문") == -1)
            this.menus.splice(
              this.menus.indexOf(this.menus.find(e => e.name == "설문")),
              1
            );
          if (this.lec.classroomOpt.indexOf("시험") == -1)
            this.menus.splice(
              this.menus.indexOf(this.menus.find(e => e.name == "시험")),
              1
            );
          //if(this.lec.classroomOpt.indexOf("동영상 등록")==-1) this.menus.splice( this.menus.indexOf(this.menus.find(e=>e.name=='강의 목차')), 1 );
          this.lec.curriculumList.forEach(e => {
            if (!e.lesList) this.$set(e, "lesList", []);
            else {
              e.lesList.forEach(e => {
                this.$set(e, "modify_", false);
                if (!e.child) this.$set(e, "child", []);
                if (!e.lesList) this.$set(e, "lesList", e.child);
                else e.lesList.forEach(e => this.$set(e, "modify_", false));
              });
            }
          });
          this.lec_ = JSON.parse(JSON.stringify(response.data.return));
          this.lec_.curriculumList.forEach(e => {
            if (!e.lesList) this.$set(e, "lesList", []);
            else {
              e.lesList.forEach(e => {
                this.$set(e, "modify_", false);
                if (!e.child) this.$set(e, "child", []);
                else e.child.forEach(e => this.$set(e, "modify_", false));
                if (!e.lesList) this.$set(e, "lesList", e.child);
                this.$set(e, "newLes_", {
                  title: "",
                  connContPath: "",
                  connContSize: "",
                  previewEnable: false,
                  connMaterial: ""
                });
              });
            }
          });
          this.selectedCurriculum = this.lec_.curriculumList[0];
          this.selectedCurriculumIdx = 0;
          if (this.lec_.curriculumList.length) {
            this.side_menus = [];
            for (let i = 0; i < this.lec_.curriculumList.length; i += 1) {
              this.side_menus.push({
                name: this.lec_.curriculumList[i].name,
                link: null,
                fn: () => {
                  this.selectedCurriculum = this.lec_.curriculumList[i];
                  this.selectedCurriculumIdx = i;
                }
              });
            }
            this.side_buttons = [];
          } else {
            this.side_menus = [{ name: "강의 목차가 없습니다.", link: "" }];
            this.side_buttons = [
              { name: "강의 목차 가져오기", fn: this.onGetCurriculum },
              { name: "새 강의 목차 만들기", fn: this.onCreateCurriculum }
            ];
          }
        });
    },
    moveUpLesGrp: function(lesGrp) {
      let currentPos = this.selectedCurriculum.lesList.indexOf(lesGrp);
      let nextPos = currentPos > 0 ? currentPos - 1 : currentPos;
      if (currentPos == nextPos) return;
      let temp = this.selectedCurriculum.lesList.splice(nextPos, 1);
      this.selectedCurriculum.lesList.splice(currentPos, 0, temp[0]);
    },
    moveDownLesGrp: function(lesGrp) {
      let currentPos = this.selectedCurriculum.lesList.indexOf(lesGrp);
      let nextPos =
        this.selectedCurriculum.lesList.length - 1 > currentPos
          ? currentPos + 1
          : currentPos;
      if (currentPos == nextPos) return;
      let temp = this.selectedCurriculum.lesList.splice(currentPos, 1);
      this.selectedCurriculum.lesList.splice(nextPos, 0, temp[0]);
    },
    modifyCurriculum: function() {
      this.modals.curriculumRegister.mode = "modify";
      this.modals.curriculumRegister.old = this.selectedCurriculum;
      this.modals.curriculumRegister.lecId = this.lec.lecId;
      this.modals.curriculumRegister.lecName = this.lec.lecName;
      this.modals.curriculumRegister.show = true;
    },
    // 새 강의 목차 만들기 시작
    onCreateCurriculum: function() {
      this.modals.curriculumRegister.mode = "register";
      this.modals.curriculumRegister.lecId = this.lec.lecId;
      this.modals.curriculumRegister.lecName = this.lec.lecName;
      this.modals.curriculumRegister.show = true;
    },
    // 강의 목차 불러오기 시작
    onGetCurriculum: function() {
      this.modals.curriculumCompile.lecId = this.lec.lecId;
      this.modals.curriculumCompile.show = true;
    },
    // 강의 목차 삭제
    deleteCurriculum: function() {
      this.modals.ModalConfirm.msg = "강좌에서 강의목차를 제거합니까?";
      this.modals.ModalConfirm.btnYes.name = "삭제";
      this.modals.ModalConfirm.btnYes.fn = () => {
        axios
          .delete(
            server.addr() +
              server.api.CURRICULUM +
              "/" +
              this.selectedCurriculum.curriculumId
          )
          .then(() => {
            this.refresh();
            this.modals.ModalConfirm.show = false;
          });
      };
      this.modals.ModalConfirm.show = true;
    },
    // 새 강의 목차 만들기 또는 강의 목차 불러오기 종료
    onCurriculumSelected: function(cur) {
      this.lec.curriculumList = cur.map(c => {
        if (!c.lesList) c.lesList = [];
        return c;
      });
      this.lec_ = JSON.parse(JSON.stringify(this.lec));
      this.lec_.curriculumList.forEach(e => {
        if (!e.lesList) this.$set(e, "lesList", []);
        else {
          this.$set(e, "modify_", false);
          e.lesList.forEach(e => {
            this.$set(e, "modify_", false);
            this.$set(e, "newLes_", {
              title: "",
              connContPath: "",
              connContSize: "",
              previewEnable: false,
              connMaterial: ""
            });
          });
        }
      });
      this.selectedCurriculum = this.lec_.curriculumList[0];
      this.selectedCurriculumIdx = 0;
      this.side_menus = [];
      for (let i = 0; i < this.lec_.curriculumList.length; i += 1) {
        this.side_menus.push({
          name: this.lec_.curriculumList[i].name,
          link: "",
          fn: () => {
            this.selectedCurriculum = this.lec_.curriculumList[i];
            this.selectedCurriculumIdx = i;
          }
        });
      }
      this.side_buttons = [];
    },
    // 차시 추가
    addLesGrp: function() {
      let lesGrpObj_ = {
        parentsId: 0,
        curriculumId: this.selectedCurriculum.curriculumId,
        title: this.newLesGroupTitle,
        ord:
          this.lec_.curriculumList[this.selectedCurriculumIdx].lesList.length +
          1,
        no:
          this.lec_.curriculumList[this.selectedCurriculumIdx].lesList.length +
          1,
        lesList: [],
        child: [],
        newLes_: {
          title: "",
          connContPath: "",
          connContPages: "",
          connMaterial: "",
          previewEnable: false,
          connContSize: "0 B"
        },
        modify_: false
      };
      let lesGrpObj = {
        parentsId: 0,
        curriculumId: this.selectedCurriculum.curriculumId,
        title: this.newLesGroupTitle,
        ord:
          this.lec.curriculumList[this.selectedCurriculumIdx].lesList.length +
          1,
        no:
          this.lec.curriculumList[this.selectedCurriculumIdx].lesList.length +
          1,
        lesList: [],
        child: [],
        newLes_: {
          title: "",
          connContPath: "",
          connContPages: "",
          connMaterial: "",
          previewEnable: false,
          connContSize: "0 B"
        },
        modify_: false
      };
      axios.put(server.addr()+"/"+server.api.LES, [lesGrpObj]).then(() => {
        this.lec_.curriculumList[this.selectedCurriculumIdx].lesList.push(lesGrpObj_);
        this.lec.curriculumList[this.selectedCurriculumIdx].lesList.push(lesGrpObj);
        this.newLesGroupTitle = "";
      });
    },
    // 차시삭제
    deleteLesGrp: function(lesGrpIdx) {
      this.modals.ModalConfirm.msg = "차시를 삭제하시겠습니까? (즉시 반영됩니다)";
      this.modals.ModalConfirm.btnNo.name = "삭제";
      this.modals.ModalConfirm.btnNo.fn = () => {
        axios.delete(server.addr() +
            server.api.LES +
            "/" +
            this.lec.curriculumList[this.selectedCurriculumIdx].lesList[lesGrpIdx].lesId).then(() => {
              this.lec.curriculumList[this.selectedCurriculumIdx].lesList.splice(
                lesGrpIdx,
                1
              );
              this.lec_.curriculumList[this.selectedCurriculumIdx].lesList.splice(
                lesGrpIdx,
                1
              );
              this.modals.ModalConfirm.show = false;
            });
      }
      this.modals.ModalConfirm.btnYes.name = "취소";
      this.modals.ModalConfirm.btnYes.fn = () => {
        this.modals.ModalConfirm.show = false;
      }
      this.modals.ModalConfirm.show = true;
    },
    // 차시수정모드 진입
    modifyLesGrp: function(lesGrpIdx) {
      this.selectedCurriculum.lesList[lesGrpIdx].modify_ = true;
    },
    // 차시수정적용
    modifyLesGrpConfirm: function(lesGrpIdx) {
      this.lec.curriculumList[this.selectedCurriculumIdx].lesList[
        lesGrpIdx
      ].title = this.selectedCurriculum.lesList[lesGrpIdx].title;
      this.selectedCurriculum.lesList[lesGrpIdx].modify_ = false;
    },
    // 단원 추가
    addLes: function(lesGrp, lesGrpIdx) {
      if (
        !this.lec_.curriculumList[this.selectedCurriculumIdx].lesList[lesGrpIdx]
          .lesList
      ) {
        this.$set(
          this.lec_.curriculumList[this.selectedCurriculumIdx].lesList[
            lesGrpIdx
          ],
          "lesList",
          []
        );
        this.$set(
          this.lec_.curriculumList[this.selectedCurriculumIdx].lesList[
            lesGrpIdx
          ],
          "child",
          []
        );
      }
      if (
        !this.lec.curriculumList[this.selectedCurriculumIdx].lesList[lesGrpIdx]
          .lesList
      ) {
        this.$set(
          this.lec.curriculumList[this.selectedCurriculumIdx].lesList[
            lesGrpIdx
          ],
          "lesList",
          []
        );
        this.$set(
          this.lec.curriculumList[this.selectedCurriculumIdx].lesList[
            lesGrpIdx
          ],
          "child",
          []
        );
      }
      let lesObj = {
        parentsId: lesGrp.lesId,
        title: lesGrp.newLes_.title,
        curriculumId: this.selectedCurriculum.curriculumId,
        connContPath: lesGrp.newLes_.connContPath,
        connContPages: lesGrp.newLes_.connContPages,
        connMaterial: lesGrp.newLes_.connMaterial,
        connContSize: lesGrp.newLes_.connContSize,
        previewEnable: lesGrp.newLes_.previewEnable,
        no: lesGrp.no,
        modify_: false
      };
      axios.put(server.addr() +
        server.api.LES, [lesObj]).then(() => {
          this.lec_.curriculumList[this.selectedCurriculumIdx].lesList[
            lesGrpIdx
          ].lesList.push(lesObj);
          this.lec_.curriculumList[this.selectedCurriculumIdx].lesList[
            lesGrpIdx
          ].child.push(lesObj);
          this.lec.curriculumList[this.selectedCurriculumIdx].lesList[
            lesGrpIdx
          ].lesList.push(lesObj);
          this.lec.curriculumList[this.selectedCurriculumIdx].lesList[
            lesGrpIdx
          ].child.push(lesObj);
          lesGrp.newLes_.title = "";
          lesGrp.newLes_.connContPath = "";
          lesGrp.newLes_.connContPages = "";
          lesGrp.newLes_.connMaterial = "";
          lesGrp.newLes_.previewEnable = false;
        });
    },
    // 단원삭제
    deleteLes: function(lesGrpIdx, lesIdx) {
      // eslint-disable-next-line
      console.log("단원 삭제를 시도하는 중", lesGrpIdx, lesIdx);
      this.modals.ModalConfirm.msg = "단원을 삭제하시겠습니까? (즉시 반영됩니다)";
      this.modals.ModalConfirm.btnNo.name = "삭제";
      this.modals.ModalConfirm.btnNo.fn = () => {
        axios.delete(server.addr() +
            server.api.LES +
            "/" +
            this.lec.curriculumList[this.selectedCurriculumIdx].lesList[lesGrpIdx].child[lesIdx].lesId).then(() => {
              this.lec.curriculumList[this.selectedCurriculumIdx].lesList[lesGrpIdx].child.splice(lesIdx, 1);
              this.lec_.curriculumList[this.selectedCurriculumIdx].lesList[lesGrpIdx].child.splice(lesIdx, 1);
              this.lec.curriculumList[this.selectedCurriculumIdx].lesList[lesGrpIdx].lesList.splice(lesIdx, 1);
              this.lec_.curriculumList[this.selectedCurriculumIdx].lesList[lesGrpIdx].lesList.splice(lesIdx, 1);
              this.modals.ModalConfirm.show = false;
            });
      }
      this.modals.ModalConfirm.btnYes.name = "취소";
      this.modals.ModalConfirm.btnYes.fn = () => {
        this.modals.ModalConfirm.show = false;
      }
      this.modals.ModalConfirm.show = true;
    },
    // 단원수정모드 진입
    modifyLes: function(lesGrpIdx, lesIdx) {
      this.selectedCurriculum.lesList[lesGrpIdx].child[lesIdx].modify_ = true;
    },
    // 단원수정적용
    modifyLesConfirm: function(lesGrpIdx, lesIdx) {
      axios.patch(server.addr()+server.api.LES+"/"+this.selectedCurriculum.lesList[lesGrpIdx].child[lesIdx].lesId, JSON.parse(JSON.stringify(this.selectedCurriculum.lesList[lesGrpIdx].child[lesIdx]))).then(() => {
        this.selectedCurriculum.lesList[lesGrpIdx].child[lesIdx].modify_ = false;
        this.lec.curriculumList[this.selectedCurriculumIdx].lesList[
          lesGrpIdx
        ].lesList[lesIdx] = JSON.parse(
          JSON.stringify(this.selectedCurriculum.lesList[lesGrpIdx].child[lesIdx])
        );
        this.lec.curriculumList[this.selectedCurriculumIdx].lesList[
          lesGrpIdx
        ].child[lesIdx] = JSON.parse(
          JSON.stringify(this.selectedCurriculum.lesList[lesGrpIdx].child[lesIdx])
        );
        this.lec_.curriculumList[this.selectedCurriculumIdx].lesList[
          lesGrpIdx
        ].lesList[lesIdx] = JSON.parse(
          JSON.stringify(this.selectedCurriculum.lesList[lesGrpIdx].child[lesIdx])
        );
        this.lec_.curriculumList[this.selectedCurriculumIdx].lesList[
          lesGrpIdx
        ].child[lesIdx] = JSON.parse(
          JSON.stringify(this.selectedCurriculum.lesList[lesGrpIdx].child[lesIdx])
        );
      })
    },
    // CMS에서 콘텐츠 불러오기 시작
    onAddCMS: function(lesGrpIdx, fieldName, isModifying) {
      if(isModifying) {
        this.modals.classContentsRegister.isModifying = true;
        this.modals.classContentsRegister.lesId = lesGrpIdx;
      } else {
        this.modals.classContentsRegister.isModifying = false;
        this.modals.classContentsRegister.lesGrpIdx = lesGrpIdx;
      }
      this.modals.classContentsRegister.fieldName = fieldName;
      this.modals.classContentsRegister.show = true;
    },
    // CMS에서 콘텐츠 불러오기 종료
    onCMSSelected: function(path, size) {
      if(this.modals.classContentsRegister.isModifying) {
        // this.selectedCurriculum에서 차시를 찾고, 강좌를 찾아서, 그걸 고친다.
        let foundLesGrp = null, foundLes = null;
        foundLesGrp = this.selectedCurriculum.lesList.find((lesGrp)=>{
          if(lesGrp.lesList.find(el=>el.lesId==this.modals.classContentsRegister.lesId)) return true;
          else return false;
        })
        if(foundLesGrp)
          foundLes = foundLesGrp.child.find((el)=>el.lesId==this.modals.classContentsRegister.lesId);
        if(foundLesGrp && foundLes) {
          foundLes[this.modals.classContentsRegister.fieldName] =
            server.cms() +
            (this.modals.classContentsRegister.fieldName == "connMaterial"
              ? "/download/"
              : "/media/") +
            path;
          if (size)
            foundLes.connContSize = size;
        }
      } else {
        this.lec_.curriculumList[this.selectedCurriculumIdx].lesList[
          this.modals.classContentsRegister.lesGrpIdx
        ].newLes_[this.modals.classContentsRegister.fieldName] =
          server.cms() +
          (this.modals.classContentsRegister.fieldName == "connMaterial"
            ? "/download/"
            : "/media/") +
          path;
        if (size) {
          this.lec_.curriculumList[this.selectedCurriculumIdx].lesList[
            this.modals.classContentsRegister.lesGrpIdx
          ].newLes_.connContSize = size;
        }
        if (path.length > 23) {
          this.$refs[
            this.modals.classContentsRegister.fieldName +
              "-" +
              this.modals.classContentsRegister.lesGrpIdx
          ][0].innerText = path.substr(0, 10) + " .... " + path.slice(-13);
        } else {
          this.$refs[
            this.modals.classContentsRegister.fieldName +
              "-" +
              this.modals.classContentsRegister.lesGrpIdx
          ][0].innerText = path;
        }
      }
      this.modals.classContentsRegister.isModifying = false;
      this.modals.classContentsRegister.lesId = 0;
      this.modals.classContentsRegister.lesGrpIdx = -1;
      this.modals.classContentsRegister.fieldName = "";
      this.modals.classContentsRegister.show = false;
    },
    // 확정저장
    onSaveComplate: function() {
      axios
        .patch(
          server.addr() +
            server.api.CURRICULUM +
            "/" +
            this.selectedCurriculum.curriculumId,
          {
            lesList: this.selectedCurriculum.lesList
          }
        )
        .then(() => {
          this.modals.ModalAlert.msg = "강의 목차 편성이 저장되었습니다.";
          this.modals.ModalAlert.show = true;
        });
    },
    dragEnd: function(lesGrpIdx) {
      // eslint-disable-next-line
      console.log(this.selectedCurriculum.lesList[lesGrpIdx].child);
    }
  },

  // 미리 계산된 option 값 들
  computed: {
    dragOptions() {
      return {
        ghostClass: "ghost"
      };
    }
  }
};
</script>
<style scope>
tr {
  height: 50px;
}
</style>